'use client';

import { useSyncExternalStore } from 'react';

/**
 * Publishes whether the chat dialog is showing a wizard surface
 * (signing-setup / deal-builder / deal-document — i.e. `isOpen &&
 * mode !== 'chat'`). The proactive card renders in that same dialog, so
 * the controller must not auto-open over a wizard. It is a reactive
 * subscription (not a ref) so that closing the wizard rebuilds the
 * controller's `handleScan` and re-invokes the scanner, reopening the
 * card — a plain `mode: 'chat'` card (proactive or emptied) never flips
 * this, so the store stays quiet during the card's own lifecycle.
 */
let wizardOpen = false;
const listeners = new Set<() => void>();

/** Set by the chat dialog provider as its mode enters/leaves a wizard. */
export function setChatWizardOpen(open: boolean): void {
  if (wizardOpen === open) return;
  wizardOpen = open;
  listeners.forEach(listener => listener());
}
function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/** True while the chat dialog shows a wizard surface. */
export function useChatWizardOpen() {
  return useSyncExternalStore(subscribe, _temp, _temp2);
}
function _temp2() {
  return false;
}
function _temp() {
  return wizardOpen;
}